module.exports = __webpack_public_path__ + "195693254e1d71c0f7597fbd80a5e943.jpg";